import * as t from './actionTypesSagas';

export const loadSettings = () => ({
  type: t.LOAD_SETTINGS,
});

export const updateKey = (key) => ({
  type: t.UPDATE_KEY,
  key,
});

export const getCommonAiAdminFeedbackTemplates = () => ({
  type: t.GET_COMMON_AI_ADMIN_FEEDBACK_TEMPLATES,
});
